/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Vue from 'vue/dist/vue.esm'
import Parallax from 'vue-parallaxy'
import VideoBg from './videobg.vue'
import MoveTo from 'moveto'
require('./top.js')
require('./tilt.js')
require('./effects.js')
import anime from 'animejs'
import ScrollReveal from 'scrollreveal'

window.sr = ScrollReveal()

document.addEventListener('readystatechange', function(evt) {
  if(evt.target.readyState == 'complete') {
    sr.reveal('.block-modal', {
      reset: true
    }, 500);
  }
})

new Vue({
  el: '#tools',
  components: {
    Parallax
  }
})

function findAncestor (el, cls) {
  if(el.classList.contains(cls)) return el;
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

function hasClass(ele,cls) {
  return ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
}

new Vue({
  el: '#entry',
  components: {
    VideoBg
  }
})

new Vue({
  el: '#oportunities',
  data: {
    active: null
  },
  methods: {
    select: function(index) {
      if(this.active == index)
        this.active = null
      else
        this.active = index
    }
  }
})

new Vue({
  el: '#company',
  data: {
    active: -1,
    title: '',
    content: ''
  },
  methods: {
    toggle: function(e) {
      if(window.innerWidth < 767) return true;
      var parent = findAncestor(e.target, 'block-modal')

      var index = Array.prototype.slice.call(this.blocks).indexOf(parent)

      this.active = index

      if(!hasClass(this.modal, 'active')) {
        this.modal.classList.add('active')
      }
    },
    setBlock: function(block) {
      this.title = getDescendantWithClass(block, 'title').innerText
      this.content = getDescendantWithClass(block, 'content').innerText
    },
    close: function() {
      this.modal.classList.remove('active')
    },
    next: function() {
      if(this.active == this.blocks.length -1) {
        this.active = 0
      } else {
        this.active = this.active + 1
      }
    },
    previous: function() {
      if(this.active == 0) {
        this.active = this.blocks.length - 1
      } else {
        this.active = this.active - 1
      }
    }
  },
  watch: {
    active: function() {
      var block = this.blocks[this.active]
      this.setBlock(block)
    }
  },
  computed: {
    modal: function() {
      return document.getElementsByClassName('modal-info')[0];
    },
    blocks: function() {
      return document.getElementsByClassName('block-modal')
    }
  },
  mounted: function() {
    this.modal.addEventListener('click', (event) => { event.stopPropagation(); })

    Array.prototype.forEach.call(document.getElementsByClassName('block-modal'), (item) => {
      item.addEventListener('click', (event) => { event.stopPropagation(); })
    })

    document.body.addEventListener('click', this.close)
  }
})

const easeFunctions = {
  easeInQuad: function (t, b, c, d) {
    t /= d;
    return c * t * t + b;
  },
  easeOutQuad: function (t, b, c, d) {
    t /= d;
    return -c * t* (t - 2) + b;
  }
}

const moveTo = new MoveTo({
  ease: 'easeInQuad',
}, easeFunctions);

const triggers = document.getElementsByClassName('js-trigger');

for (var i = 0; i < triggers.length; i++) {
  moveTo.registerTrigger(triggers[i]);
}

function getDescendantWithClass(element, clName) {
  var children = element.childNodes;
  for (var i = 0; i < children.length; i++) {
      if (children[i].className &&
          children[i].className.split(' ').indexOf(clName) >= 0) {
          return children[i];
       }
   }
   for (var i = 0; i < children.length; i++) {
       var match = getDescendantWithClass(children[i], clName);
       if (match !== null) {
           return match;
       }
   }
   return null;
}



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js